export const ebpCaseEmails = {
  PcpToHealixNurse: {
    id: 'ebp-pcp-to-nurse',
    name: 'PCP to Healix nurse',
  },
  // Paubox. Organization-agnostic (PPL-3027) — gated by the org's
  // `careDocuments.canSendToCaseManager` setting.
  ToCaseManagerDocument: {
    id: 'ebp-document-to-case-manager',
    name: 'To case manager "Document"',
  },
  // Paubox. The Return to Work Plan to the employer contact captured on the
  // Aviva referral (PPL-3293); the member is always CC'd.
  ToEmployerDocument: {
    id: 'ebp-document-to-employer',
    name: 'To employer "Document"',
  },
  // Paubox. Historical id — kept only so existing email records still
  // display and resend; new sends use ToCaseManagerDocument.
  ToLandgCaseManagerDocument: {
    id: 'ebp-document-to-landg-case-manager',
    name: 'To L&G case manager "Document"',
  },
  // Paubox. Historical id — see ToCaseManagerDocument.
  ToAvivaCaseManagerDocument: {
    id: 'ebp-document-to-aviva-case-manager',
    name: 'To Aviva case manager "Document"',
  },
};

export const ebpCaseEmailIds = Object.values(ebpCaseEmails).map((v) => v.id);
